enum OrderType {
  CustInvc = 'CustInvc',
  SalesOrd = 'SalesOrd',
}
export default OrderType;
